import React, { Component } from "react";
import PropTypes from "prop-types";
import Checkbox from "react-md/lib/SelectionControls/Checkbox";
import Autocomplete from "react-md/lib/Autocompletes";
import List from "react-md/lib/Lists/List";
import ListItemControl from "react-md/lib/Lists/ListItemControl";
import Avatar from "react-md/lib/Avatars";
import Tooltipped from "react-md/lib/Tooltips/Tooltipped";
import cloneDeep from "lodash/cloneDeep";
import Button from "react-md/lib/Buttons/Button";
import { CustomerShape } from "../../../../common/proptypes";

const validate = (ranges, customers) => {
  let isValid = true;
  let error = null;

  if (ranges && !ranges.pistolRange && !ranges.rifleRange) {
    error = "Check at least one range";
    isValid = false;
  }

  if (customers && customers.length === 0) {
    error = "Select at least one customer";
    isValid = false;
  }

  return {
    isValid,
    error,
  };
};

class QuickAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customers: [],
      phone: "",
      pistolRange: false,
      rifleRange: false,
      rental: false,
      error: "",
      synchronized: false,
      isSynchronizing: false,
    };

    this.handleSearchCustomer = this.handleSearchCustomer.bind(this);
    this.handleSelectCustomer = this.handleSelectCustomer.bind(this);
    this.handleRemoveCustomer = this.handleRemoveCustomer.bind(this);
    this.handleAddCustomer = this.handleAddCustomer.bind(this);
    this.handleSync = this.handleSync.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillUnmount() {
    this.props.onClearSearchCustomerResult();
    this.props.onClearQuickAdd();
  }

  handleChange(field, value) {
    this.setState((prevState) => {
      const newState = {
        [field]: value,
      };

      const ranges = {
        pistolRange: prevState.pistolRange,
        rifleRange: prevState.rifleRange,
      };
      ranges[field] = value;
      const { error } = validate(ranges);
      newState.error = error;

      return newState;
    });
  }

  handleSearchCustomer(phone) {
    this.setState(() => ({
      phone,
    }));
    this.props.onSearchCustomerByPhone(phone);
  }

  handleSelectCustomer(item, itemIndex, items) {
    this.setState((prevState) => {
      const customers = [...prevState.customers, items[itemIndex]];

      const { error } = validate(null, customers);

      return {
        customers,
        phone: "",
        error,
      };
    });

    const { onAddCustomerToQuickAdd } = this.props;
    onAddCustomerToQuickAdd(items[itemIndex]);
  }

  handleRemoveCustomer(customerKey) {
    // this.setState((prevState) => {
    //   const customers = cloneDeep(prevState.customers).filter(
    //     (customer) => customer.idNumber !== idNumber
    //   );
    //   const { error } = validate(null, customers);
    //   return {
    //     customers,
    //     error,
    //   };
    // });
    const { onRemoveCustomerFromQuickAdd } = this.props;
    onRemoveCustomerFromQuickAdd(customerKey);
  }

  handleAddCustomer() {
    const { customersToQuickAdd } = this.props;
    const { isValid, error } = validate(
      {
        pistolRange: this.state.pistolRange,
        rifleRange: this.state.rifleRange,
      },
      customersToQuickAdd
    );
    if (!isValid) {
      this.setState(() => ({
        error,
      }));
      return;
    }

    const { rangeLocation, onQuickAddCustomer } = this.props;
    const customers = cloneDeep(customersToQuickAdd);

    onQuickAddCustomer(rangeLocation, {
      customers,
      ranges: {
        rifle: this.state.rifleRange,
        pistol: this.state.pistolRange,
      },
      rental: this.state.rental,
    });
  }

  handleSync() {
    const { onSynchronizeCustomers, customersToQuickAdd } = this.props;
    const customers = cloneDeep(customersToQuickAdd);

    onSynchronizeCustomers(customers);
  }

  render() {
    const { searchResult } = this.props;
    let revisedSearchResult = [];
    let deleteKeys = [
      "address",
      "address2",
      "city",
      "country",
      "created",
      "customer",
      "dateOfBirth",
      "email",
      "firstName",
      "idNumber",
      "idType",
      "lastName",
      "phone",
      "postal",
      "province",
      "updated",
      "key",
      "description",
      "issues",
    ];
    if (searchResult && searchResult.length > 0) {
      // remove selected customers
      revisedSearchResult = searchResult.filter((customer) => {
        const isAdded =
          this.state.customers.filter(
            (addedCustomer) => addedCustomer.idNumber === customer.idNumber
          ).length > 0;
        return !isAdded;
      });
      revisedSearchResult = revisedSearchResult.map((customer) => ({
        ...customer,
        description: `${customer.firstName} ${customer.lastName} - ${
          customer.phone
        } ${customer.member && customer.active ? "- M" : "- NON MEMBER"}`,
      }));
    }
    return (
      <div className="md-grid" style={{ paddingTop: 20 }}>
        <h6 className="md-cell md-cell--12 md-title">Quick Add</h6>
        <div className="md-cell md-cell--4 md-subheading-2 md-cell--middle">
          Pick Range(s) Type:
        </div>
        <div className="md-cell md-cell--8">
          <div className="md-grid md-grid--no-spacing">
            <Checkbox
              id="pistol"
              name="pistol"
              label="Handgun"
              defaultChecked={this.state.pistolRange}
              value={this.state.pistolRange}
              onChange={(value) => this.handleChange("pistolRange", value)}
            />
            <Checkbox
              id="rifle"
              name="rifle"
              label="Rifle"
              defaultChecked={this.state.rifleRange}
              value={this.state.rifleRange}
              onChange={(value) => this.handleChange("rifleRange", value)}
            />
          </div>
        </div>

        <div className="md-cell md-cell--4 md-subheading-2 md-cell--middle">
          Renting A Firearm:
        </div>
        <div className="md-cell md-cell--8">
          <div className="md-grid md-grid--no-spacing">
            <Checkbox
              id="rental"
              name="rental"
              value={this.state.rental}
              onChange={(value) => this.handleChange("rental", value)}
            />
          </div>
        </div>

        {this.props.customersToQuickAdd &&
          this.props.customersToQuickAdd.length > 0 && (
            <List className="md-cell md-cell--12 md-paper md-paper--1">
              {this.props.customersToQuickAdd.map((customer) => (
                <ListItemControl
                  key={customer.key}
                  // leftAvatar={
                  //   <Avatar
                  //     suffix="red"
                  //     icon={<FontIcon>perm_identity</FontIcon>}
                  //   />
                  // }
                  leftAvatar={
                    customer.member && customer.active ? (
                      <Tooltipped
                        label="Active Member"
                        position="right"
                        setPosition
                      >
                        <span style={{ marginLeft: "10px" }}>
                          <Avatar role="presentation" suffix="green">
                            M
                          </Avatar>
                        </span>
                      </Tooltipped>
                    ) : (
                      <Tooltipped
                        label="NON MEMBER"
                        position="right"
                        setPosition
                      >
                        <span style={{ marginLeft: "10px" }}>
                          <Avatar
                            role="presentation"
                            suffix="grey"
                            onClick={this.handleIconClick}
                          >
                            NM
                          </Avatar>
                        </span>
                      </Tooltipped>
                    )
                  }
                  secondaryAction={
                    <Checkbox
                      id={`remove-${customer.key}`}
                      name={`remove-${customer.key}`}
                      //key={customer.key}
                      label={`${customer.firstName} ${customer.lastName}`}
                      labelBefore
                      defaultChecked
                      checkedIconChildren="delete"
                      uncheckedIconChildren="delete"
                      onChange={() => this.handleRemoveCustomer(customer.key)}
                    />
                  }
                />
              ))}
            </List>
          )}
        <Autocomplete
          id="customerPhone"
          label="Customer Phone Number"
          className="md-cell md-cell--12"
          placeholder="Type customer phone number to search"
          data={revisedSearchResult}
          dataLabel="description"
          dataValue="key"
          deleteKeys={deleteKeys}
          value={this.state.phone}
          onChange={this.handleSearchCustomer}
          onAutocomplete={this.handleSelectCustomer}
        />

        {this.state.error && (
          <div className="md-cell md-cell--12" style={{ color: "#B71C1C" }}>
            {this.state.error}
          </div>
        )}
        <div className="md-cell md-cell--12">
          {!this.props.synchronized || this.props.synchronizingCustomers ? (
            <Button
              primary
              raised
              label={
                this.props.synchronizingCustomers ? "Checking" : "Check Status"
              }
              onClick={this.handleSync}
              disabled={
                this.state.customers.length === 0 ||
                !!this.state.error ||
                this.props.synchronizingCustomers
              }
            />
          ) : (
            <Button
              primary
              raised
              label="Quick Add"
              onClick={this.handleAddCustomer}
              disabled={!!this.state.error}
            />
          )}
        </div>
      </div>
    );
  }
}

QuickAdd.propTypes = {
  searchResult: PropTypes.arrayOf(CustomerShape),
  onSearchCustomerByPhone: PropTypes.func.isRequired,
  onQuickAddCustomer: PropTypes.func.isRequired,
  onClearSearchCustomerResult: PropTypes.func.isRequired,
  rangeLocation: PropTypes.string.isRequired,
};

QuickAdd.defaultProps = {
  searchResult: {},
};

export default QuickAdd;



// WEBPACK FOOTER //
// ./src/staff/components/QuickAddDrawer/QuickAdd/QuickAdd.jsx